import Api from "@/services/Api";
export default {
  getIndicesFromApi(tradedate) {
    var url = "indices" + this.formatUrl(tradedate);
    return Api().get(url);
  },
  getSharePricesFromApi(tradedate) {
    var url = "shareprices" + this.formatUrl(tradedate);
    return Api().get(url);
  },
  getAgmsFromApi(fy) {
    var url = "agms" + (fy == "" ? "" : "/" + encodeURIComponent(fy));
    return Api().get(url);
  },
  getDividendsFromApi(fy) {
    var url = "dividends" + (fy == "" ? "" : "/" + encodeURIComponent(fy));
    return Api().get(url);
  },
  getRightSharesFromApi() {
    var url = "rights";
    return Api().get(url);
  },
  getNoticesFromApi() {
    var url = "notices";
    return Api().get(url);
  },
  formatUrl(tradedate) {
    return tradedate == ""
      ? ""
      : "/" +
          (tradedate.toString().length > 10
            ? tradedate.toISOString().slice(0, 10)
            : tradedate);
  },
};
